var render, staticRenderFns
import script from "./MissingWordMixin.vue?vue&type=script&lang=js"
export * from "./MissingWordMixin.vue?vue&type=script&lang=js"
import style0 from "./MissingWordMixin.vue?vue&type=style&index=0&id=e4b9bb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports